/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceEarningRuleItem
 */
export interface SurfaceEarningRuleItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceEarningRuleItem
     */
    points?: number;
    /**
     * Icon identifier (e.g. "trophy", "crosshair", "handshake", "gamepad", "star")
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    icon?: string;
    /**
     * Free-form grouping key used to colour-code this rule, e.g. "social" or "purchase". Letters, digits and hyphens; omit for a neutral treatment.
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    category?: string;
    /**
     * Long-form body for the card's detail view — the "more info" a click opens. Omitted, the detail view shows only the summary fields.
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    details?: string;
    /**
     * The assigned objective this card claims against. Present, the card's detail view mounts the claim flow named by claimAction; absent, the card is informational only.
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    objectiveTemplateId?: string;
    /**
     * Which platform claim flow the card's detail view mounts — the earn capabilities, never a brand-specific value. QR is informational (claims happen through the physical code's deep link).
     * @type {string}
     * @memberof SurfaceEarningRuleItem
     */
    claimAction?: SurfaceEarningRuleItemClaimActionEnum;
}


/**
 * @export
 */
export const SurfaceEarningRuleItemClaimActionEnum = {
    SERIAL_VERIFY: 'SERIAL_VERIFY',
    SOCIAL_FOLLOW: 'SOCIAL_FOLLOW',
    SOCIAL_LIKE: 'SOCIAL_LIKE',
    SOCIAL_POST: 'SOCIAL_POST',
    QR: 'QR'
} as const;
export type SurfaceEarningRuleItemClaimActionEnum = typeof SurfaceEarningRuleItemClaimActionEnum[keyof typeof SurfaceEarningRuleItemClaimActionEnum];


/**
 * Check if a given object implements the SurfaceEarningRuleItem interface.
 */
export function instanceOfSurfaceEarningRuleItem(value: object): value is SurfaceEarningRuleItem {
    return true;
}

export function SurfaceEarningRuleItemFromJSON(json: any): SurfaceEarningRuleItem {
    return SurfaceEarningRuleItemFromJSONTyped(json, false);
}

export function SurfaceEarningRuleItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceEarningRuleItem {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'points': json['points'] == null ? undefined : json['points'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'category': json['category'] == null ? undefined : json['category'],
        'details': json['details'] == null ? undefined : json['details'],
        'objectiveTemplateId': json['objectiveTemplateId'] == null ? undefined : json['objectiveTemplateId'],
        'claimAction': json['claimAction'] == null ? undefined : json['claimAction'],
    };
}

export function SurfaceEarningRuleItemToJSON(json: any): SurfaceEarningRuleItem {
    return SurfaceEarningRuleItemToJSONTyped(json, false);
}

export function SurfaceEarningRuleItemToJSONTyped(value?: SurfaceEarningRuleItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'description': value['description'],
        'points': value['points'],
        'icon': value['icon'],
        'category': value['category'],
        'details': value['details'],
        'objectiveTemplateId': value['objectiveTemplateId'],
        'claimAction': value['claimAction'],
    };
}

